/* 온제나 블로그 글 — 목차 · 읽기 진행바 · 공유
   워드프레스 onz-article-js 에서 이식(2026-09-04).
   달라진 곳 하나: 워드프레스는 JS 가 히어로·목차 껍데기·2단 그리드를 통째로 만들었지만,
   여기서는 그것을 Liquid 가 서버에서 렌더하므로 JS 는 목차 '항목'만 채운다.
   진행바·공유·수정일 블록은 원본 그대로다(워드프레스 의존 코드가 없다). */
(function(){
  document.addEventListener("DOMContentLoaded", function(){
    var content = document.querySelector(".entry-content");
    var toc     = document.querySelector(".onz-toc");
    if (!content || !toc) return;

    var list   = toc.querySelector(".onz-toc-list");
    var toggle = toc.querySelector(".onz-toc-toggle");
    var label  = toc.querySelector(".onz-toc-label");
    var tocText = (label && label.textContent.trim()) || "In This Article";

    var headings = Array.from(content.querySelectorAll("h2, h3")).filter(function(h){
      return !h.closest(".onz-recent-wrap, .onz-bottom-carousel, .onz-mid-pick");
    });
    var h2Count = headings.filter(function(h){ return h.tagName === "H2"; }).length;

    /* 워드프레스와 같은 기준: h2 가 2개 미만이면 목차를 두지 않는다.
       서버가 이미 자리를 그렸으므로 만들지 않는 대신 숨기고 1단으로 되돌린다. */
    if (h2Count < 2) {
      toc.remove();
      var layout = document.querySelector(".onz-article-layout");
      if (layout) layout.style.gridTemplateColumns = "1fr";
      return;
    }

    headings.forEach(function(h, i){
      if (!h.id) {
        var slug = h.textContent.toLowerCase()
          .replace(/[^a-z0-9\s-]/g, "").trim()
          .replace(/\s+/g, "-").replace(/-+/g, "-").slice(0, 60) || ("s" + i);
        h.id = "onz-" + slug;
      }
    });

    if (list) {
      list.innerHTML = "";
      headings.forEach(function(h){
        var li = document.createElement("li");
        if (h.tagName === "H3") li.className = "onz-toc-h3";
        var a = document.createElement("a");
        a.href = "#" + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
    }

    if (toggle) {
      toggle.textContent = "\u25bc " + tocText;
      toggle.addEventListener("click", function(){
        var open = toc.classList.toggle("onz-toc--open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        toggle.textContent = (open ? "\u25b2" : "\u25bc") + " " + tocText;
      });
    }

    /* 지금 보고 있는 절을 목차에서 표시 */
    if (list) {
      var links = Array.from(list.querySelectorAll("a"));
      var activeId = null;
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) activeId = e.target.id; });
        links.forEach(function(a){
          a.classList.toggle("onz-toc-active", a.getAttribute("href") === "#" + activeId);
        });
      }, { rootMargin: "-20% 0px -70% 0px" });
      headings.forEach(function(h){ obs.observe(h); });
    }
  });

  /* ════════════════════════════════════════════
     READING PROGRESS BAR
     ════════════════════════════════════════════ */
  var progressBar = document.createElement("div");
  progressBar.className = "onz-progress-bar";
  document.body.insertBefore(progressBar, document.body.firstChild);
  function updateProgress() {
    var article = document.querySelector(".entry-content") || document.querySelector("article");
    if (!article) return;
    var rect = article.getBoundingClientRect();
    var articleH = article.offsetHeight;
    var scrolled = -rect.top;
    var pct = Math.min(100, Math.max(0, (scrolled / (articleH - window.innerHeight)) * 100));
    progressBar.style.width = pct + "%";
  }
  window.addEventListener("scroll", updateProgress, { passive: true });
  updateProgress();

  /* ════════════════════════════════════════════
     SOCIAL SHARE BUTTONS
     ════════════════════════════════════════════ */
  (function() {
    var pageUrl = encodeURIComponent(window.location.href);
    var pageTitle = encodeURIComponent(document.title);
    var ogImg = "";
    var ogImgMeta = document.querySelector("meta[property=\"og:image\"]");
    if (ogImgMeta) ogImg = encodeURIComponent(ogImgMeta.getAttribute("content") || "");
    var ogDesc = "";
    var ogDescMeta = document.querySelector("meta[property=\"og:description\"]");
    if (ogDescMeta) ogDesc = encodeURIComponent(ogDescMeta.getAttribute("content") || "");

    var shares = [
      { id:"pinterest", label:"Pin",
        icon:"<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z\"/></svg>",
        url: function(){ return "https://pinterest.com/pin/create/button/?url=" + pageUrl + "&media=" + ogImg + "&description=" + ogDesc; }
      },
      { id:"facebook", label:"Share",
        icon:"<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z\"/></svg>",
        url: function(){ return "https://www.facebook.com/sharer/sharer.php?u=" + pageUrl; }
      },
      { id:"twitter", label:"Tweet",
        icon:"<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z\"/></svg>",
        url: function(){ return "https://twitter.com/intent/tweet?text=" + pageTitle + "&url=" + pageUrl; }
      },
      { id:"copy", label:"Copy",
        icon:"<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path></svg>",
        action: function(btn){
          navigator.clipboard.writeText(window.location.href).then(function(){
            var lbl = btn.querySelector(".onz-share-label");
            if(lbl){ lbl.textContent="Copied!"; setTimeout(function(){ lbl.textContent="Copy"; },2000); }
          });
        }
      }
    ];

    function makeBtn(s, cls){
      var btn = document.createElement("a");
      btn.className = "onz-share-btn " + cls;
      btn.setAttribute("aria-label", "Share on " + s.label);
      btn.innerHTML = s.icon + "<span class=\"onz-share-label\">" + s.label + "</span>";
      if(s.url){ btn.href = s.url(); btn.target = "_blank"; btn.rel = "noopener noreferrer"; }
      else if(s.action){ btn.href = "#"; btn.addEventListener("click", function(e){ e.preventDefault(); s.action(btn); }); }
      return btn;
    }

    /* Desktop sidebar */
    var sidebar = document.createElement("div");
    sidebar.className = "onz-share-sidebar";
    shares.forEach(function(s){ sidebar.appendChild(makeBtn(s, "onz-share-btn--vert")); });
    document.body.appendChild(sidebar);

    /* Hide sidebar before product carousel / Keep Reading / tags area */
    var cutoffEl = document.querySelector(".onz-bestsellers--post")
      || document.querySelector(".onz-recent-wrap")
      || document.querySelector(".entry-footer, .post-tags, .tag-links");
    if (cutoffEl) {
      function checkSidebarBounds() {
        var rect = cutoffEl.getBoundingClientRect();
        var hide = rect.top < window.innerHeight * 0.6;
        sidebar.style.opacity = hide ? "0" : "1";
        sidebar.style.pointerEvents = hide ? "none" : "auto";
      }
      window.addEventListener("scroll", checkSidebarBounds, { passive: true });
      checkSidebarBounds();
    }

    /* Mobile bottom bar */
    var bar = document.createElement("div");
    bar.className = "onz-share-bar";
    if(navigator.share){
      var nBtn = document.createElement("button");
      nBtn.className = "onz-share-btn--native";
      nBtn.innerHTML = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><circle cx=\"18\" cy=\"5\" r=\"3\"/><circle cx=\"6\" cy=\"12\" r=\"3\"/><circle cx=\"18\" cy=\"19\" r=\"3\"/><line x1=\"8.59\" y1=\"13.51\" x2=\"15.42\" y2=\"17.49\"/><line x1=\"15.41\" y1=\"6.51\" x2=\"8.59\" y2=\"10.49\"/></svg><span class=\"onz-share-label\">Share</span>";
      nBtn.addEventListener("click", function(){ navigator.share({ title: document.title, url: window.location.href }); });
      bar.appendChild(nBtn);
    }
    shares.forEach(function(s){ bar.appendChild(makeBtn(s, "onz-share-btn--horiz")); });
    document.body.appendChild(bar);
  })();

  /* ════════════════════════════════════════════
     LAST UPDATED DATE
     ════════════════════════════════════════════ */
  var modSpan = document.getElementById("onz-modified-date");
  var authorInfo = document.querySelector(".onz-author-block-info");
  if (modSpan && authorInfo) {
    var modDate = modSpan.getAttribute("data-date");
    var pubMatch = authorInfo.innerHTML.match(/\u00b7\s*([A-Z][a-z]+ \d+, \d{4})/);
    var pubDate = pubMatch ? pubMatch[1] : "";
    if (modDate && modDate !== pubDate) {
      var modEl = document.createElement("span");
      modEl.className = "onz-read-time-text onz-modified-date";
      modEl.innerHTML = " \u00b7 Updated " + modDate;
      authorInfo.appendChild(modEl);
    }
  }

})();
